import { useLayoutEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { initialLocale, LocaleContext, LOCALES, saveLocale } from '@/lib/locale'

import Footer from './Footer'
import Header from './Header'
import ScrollToTop from './ScrollToTop'

/**
 * Every page opens with a photo hero; the fixed header floats over it.
 * Layout also owns the language: it provides it to the tree and mirrors it
 * onto <html lang dir>, so Arabic flips the whole page right-to-left.
 */
export default function Layout() {
  const [locale, setLocale] = useState(initialLocale)

  // Before paint, so an Arabic visitor never sees one left-to-right frame.
  useLayoutEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = LOCALES[locale].dir
  }, [locale])

  const toggle = () => {
    const next = locale === 'en' ? 'ar' : 'en'
    saveLocale(next)
    setLocale(next)
  }

  return (
    <LocaleContext value={{ locale, toggle }}>
      {/* Arabic: letter-spacing breaks the joined script, and its marks need
          taller headings. Text marked lang="en" (the wordmarks) keeps Latin
          spacing.
          No sideways scrolling: cards that slide in start beyond the screen
          edge, and a phone would otherwise zoom the whole page out to fit
          them. `clip` (not `hidden`) keeps the sticky sections working. */}
      <div className="flex min-h-svh flex-col overflow-x-clip [&_:is(h1,h2,h3):lang(ar)]:leading-[1.3] [&_:lang(ar)]:tracking-[normal]">
        <ScrollToTop />
        <Header />
        <main className="flex flex-1 flex-col">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LocaleContext>
  )
}
